import { Component, OnInit, Input } from '@angular/core';
import { PriceModifier, Registration, RegistrationPriceModifier } from 'src/app/domain/ot-event';
import { L10nService } from '../../services/l10n.service';

@Component({
  selector: 'app-registration-pricing-info',
  templateUrl: './registration-pricing-info.component.html',
  styleUrls: ['./registration-pricing-info.component.scss']
})
export class RegistrationPricingInfoComponent implements OnInit {

  @Input()
  public registration: Registration;

  @Input()
  public changeLink: string;

  public discounts = [];

  public premiums = [];

  constructor(private l10nService: L10nService) { }

  ngOnInit() {
    if (this.registration.registrationPriceModifiers) {
      this.registration.registrationPriceModifiers.forEach(registrationPriceModifier => {
        if (registrationPriceModifier.priceModifier.type.isDiscount) {
          this.discounts.push(registrationPriceModifier);
        } else {
          this.premiums.push(registrationPriceModifier);
        }
      });
    }
  }

  public priceModifierName(registrationpriceModifier: RegistrationPriceModifier): string {
    const priceModifier = registrationpriceModifier.priceModifier;
    if (priceModifier.name) {
      return priceModifier.name;
    }
    if (priceModifier.typeCode === 'SocialDiscount') {
      let discountName = this.l10nService.get('price_socialDiscount');

      if (priceModifier.socialDiscount && priceModifier.socialDiscount.socialGroups) {
        discountName += registrationpriceModifier['registrationSocialDiscount'].socialGroup.accusative;
      }
      return discountName;
    }
    if (priceModifier.typeCode === 'PartialCourseDiscount') {
      return this.l10nService.get('price_lateRegDiscountInfo');
    }
  }
}
